import reportService from "@/services/ReportCarWashService";
import M from "materialize-css";
import General from "@/assets/langpacks/General";
export default {
  name: "ReportCarWash",
  data: () => ({
    ReportData: [],

    UserID: 0,
    UserList: [],
    ServiceList: [],
    PolicyNumber: "",
    CarNumber: "",
    StartSendDate: null,
    EndSendDate: null,
    StartAppoveDate: null,
    EndAppoveDate: null,
    ServiceID: 0,
    DateTimeOptions: null,
  }),
  components: {},
  mounted() {
    console.log("asd");
    this.DateTimeOptions = {
      format: "yyyy-mm-dd",
      i18n: {
        months: General.Months.geo,
        monthsShort: General.Months.geoShort,
        weekdays: General.WeekDays.geo,
        weekdaysShort: General.WeekDays.geoShort,
        weekdaysAbbrev: General.WeekDays.geoAbbrev,
        cancel: "გაუქმება",
        done: "არჩევა",
      },
    };
    reportService.GetReportInitData().then((res) => {
      this.UserList = res.userList;
      this.InitMaterializeComponents();
      this.CarWashList = res.carWashList;
      this.ServiceList = res.limitList;
      this.GetData();
    });
  },

  methods: {
    InitMaterializeComponents() {
      this.$nextTick(function () {
        M.FormSelect.init(this.$refs.UserSelect, {});

        M.Datepicker.init(this.$refs.StartSendDate, this.DateTimeOptions);
        M.Datepicker.init(this.$refs.EndSendDate, this.DateTimeOptions);

        M.Datepicker.init(this.$refs.StartAppoveDate, this.DateTimeOptions);
        M.Datepicker.init(this.$refs.EndAppoveDate, this.DateTimeOptions);

        M.FormSelect.init(this.$refs.ServiceSelect, {});
        M.updateTextFields();
      });
    },
    ClearFilter() {
      this.PolicyNumber = null;
      this.CarNumber = null;
      this.UserID = 0;
      this.StartSendDate = null;
      this.EndSendDate = null;
      this.StartAppoveDate = null;
      this.EndAppoveDate = null;
      this.InitMaterializeComponents();
      this.GetData();
    },
    GetData() {
      reportService
        .GetReportData(
          this.PolicyNumber,
          this.CarNumber,
          this.UserID == 0 ? null : this.UserID,
          this.ServiceID == 0 ? null : this.ServiceID,
          this.StartSendDate,
          this.EndSendDate,
          this.StartAppoveDate,
          this.EndAppoveDate
        )
        .then((res) => {
          this.ReportData = res.data;
        });
    },
    DownloadData() {
      reportService
        .GetReportData(
          this.PolicyNumber,
          this.CarNumber,
          this.UserID == 0 ? null : this.UserID,
          this.ServiceID == 0 ? null : this.ServiceID,
          this.StartSendDate,
          this.EndSendDate,
          this.StartAppoveDate,
          this.EndAppoveDate,          
          true
        );        
    }
  },
};
